import axiosInstance from '../../../utils/axios';
import { ROLE } from '../../../utils/Constants';
const options = { role: ROLE.SUPER_ADMIN };
const path = 'admin/inquiry-email-templates';

export const List    = (values) => axiosInstance(options).post(`${path}/list`, values);
export const Add     = (values) => axiosInstance(options).post(`${path}/add`, values);
export const Edit    = (values) => axiosInstance(options).post(`${path}/edit`, values);
export const Delete  = (values) => axiosInstance(options).post(`${path}/delete`, values);
export const Details = (id)     => axiosInstance(options).get(`${path}/details?o_id=${id}`);
export const Status  = (values) => axiosInstance(options).post(`${path}/change-status`, values);
export const Options = (values) => axiosInstance(options).post(`${path}/options`, values);
